import PropTypes from 'prop-types'
import React from 'react'

export const RotateRightBtn = ({item, index, onClick}) =>
  <div>
    <span className='rotate-btn' data-id={item.id} data-tmpid={item.tmpId} data-index={index} onClick={onClick}>
    &#8635;
    </span>
  </div>

RotateRightBtn.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    id: PropTypes.number,
    tmpId: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
}

RotateRightBtn.defaultProps = {
  index: 0
}
